import {Injectable} from '@angular/core';

@Injectable()
export class CsvService {

  constructor() {
  }


  downloadCSV(csv: string, fileName: string) {
    const blob = new Blob([csv], {
      type: 'text/csv;charset=utf-8;'
    });
    const link = document.createElement('a');
    link.style.display = 'none';
    document.body.appendChild(link);
    if (link.download !== undefined) {
      link.setAttribute('href', URL.createObjectURL(blob));
      link.setAttribute('download', fileName);
      link.click();
    } else {
      csv = 'data:text/csv;charset=utf-8,' + csv;
      window.open(encodeURI(csv));
    }
    document.body.removeChild(link);
  }

  addCsvLine(csv: string, csvCols: any[], object: any) {
    csv += '\n';
    for (let j = 0; j < csvCols.length; j++) {
      const col = csvCols[j];
      let cellData = null;
      if (col.field === 'customerId') {
        cellData = '"' + object[col.field] + '"';
      } else {
        cellData = object[col.field];
      }
      if (cellData != null) {
        cellData = String(cellData).replace(/"/g, '""');
      } else {
        cellData = '';
      }
      csv += '"' + cellData + '"';
      if (j < (csvCols.length - 1)) {
        csv += ',';
      }
    }
    return csv;
  }

}
